
















































// require('./lib/ui/root.js');

import inlineTextEdit from "../../components/inlineTextEdit.vue"
import multiLineEdit from "../../components/multiLineEdit.vue"
import ripple from "../../components/ripple.vue"
import tooltip from "../../components/tooltip.vue"
import gbutton from "../../components/button.vue"
import graph from "../../components/lineGraph.js"

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { setInterval } from "timers";
import { frontendClient } from "../../lib/client";
import moment,{ weekdays, invalid} from "moment";

@Component({
    components : {
        ripple,
        gbutton,
        multiLineEdit,
        inlineTextEdit,
        graph,
        tooltip,
    },
})
export default class Alerts extends Vue{
    alerts:{
        title: string,
        body: string,
        timestamp: number,
        date:(String | Date);
    }[] = null;

    mounted(){
       this.$emit('scope','alerts');
       this.getAlerts();

       //moment(this.alert.timestamp).format("ddd, DD/MM/YYYY")
    }

    async getAlerts(){
        this.alerts = await frontendClient.post("alerts/latest",{});

        for(let i=0; i<this.alerts.length; i++){
            this.alerts[i].date = moment(this.alerts[i].timestamp).format("ddd, DD/MM/YYYY");
        }
    }

    editAlert(alert){
        this.$emit('editPrompt',{instance:'alert',object:alert});
    }
    deleteAlert(alert){
        let idx = this.alerts.indexOf(alert);

        if(idx !== -1) {
            this.alerts.splice(idx,1);
            frontendClient.postEx("alerts/delete", {
                id: alert.id
            });
        }
    }

    newAlert(){
        this.$emit('newPrompt','alert');
    }

}
